import logo from "../assets/images/logo/logo.png";
// import certificate1 from "../assets/images/certificate1.png";
// import certificate2 from "../assets/images/certificate2.png";

export default function About() {
  return (
    <div className="min-h-screen bg-[#020617] pb-10">
      <div className="mx-auto max-w-[600px] px-3 pt-6">
        {/* Glass Card */}
        <div className=" flex flex-col items-center gap-6 rounded-md border border-white/10 bg-white/5 backdrop-blur-xl shadow-2xl">
          {/* Logo */}
          <img
            src={logo}
            alt="TradeWin AI Logo"
            className="w-40 object-contain pt-2"
          />

          {/* Certificates */}
          {/* <div className="flex w-full flex-col items-center gap-5 px-3">
            <img
              src={certificate1}
              alt="TradeWin AI Certificate 1"
              className="w-full max-w-[450px] rounded-xl border border-white/20 bg-white/5 p-4 transition-all duration-300 hover:-translate-y-2 hover:border-cyan-400/50 hover:shadow-[0_15px_30px_rgba(34,211,238,0.35)]"
            />

            <img
              src={certificate2}
              alt="TradeWin AI Certificate 2"
              className="w-full max-w-[450px] rounded-xl border border-white/20 bg-white/5 p-4 transition-all duration-300 hover:-translate-y-2 hover:border-cyan-400/50 hover:shadow-[0_15px_30px_rgba(34,211,238,0.35)]"
            />
          </div> */}

          {/* About Section */}
          <div className="mb-5 mt-2 w-full px-4 text-center">
            <h2 className="mb-3 text-lg font-semibold tracking-wide text-cyan-300">
              About Us
            </h2>

            <p className="mx-auto max-w-[500px] text-[15px] leading-relaxed text-slate-300">
              <span className="font-medium text-cyan-200">TradeWin AI</span> is
              a next-generation trading and financial services company focused
              on empowering traders with transparent, secure, and
              technology-driven solutions.
              <br />
              <br />
              Our global expansion strategy targets high-growth financial
              markets while integrating local regulatory frameworks and
              financial ecosystems. TradeWin AI is committed to building a
              strong international presence through strategic partnerships and
              regional offices.
              <br />
              <br />
              We have successfully initiated regulatory processes with
              international financial authorities, reinforcing our commitment to
              compliance, trust, and long-term value creation.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
